import api, { unwrap } from './client';

// Offre : le catalogue des produits et services (module Ventes).
export const listOffers = (tenantId) => unwrap(api.get(`/sales-offers/${tenantId}`));
export const createOffer = (tenantId, payload) => unwrap(api.post(`/sales-offers/${tenantId}`, payload));
export const updateOffer = (tenantId, offerId, payload) => unwrap(api.patch(`/sales-offers/${tenantId}/${offerId}`, payload));
export const deleteOffer = (tenantId, offerId) => unwrap(api.delete(`/sales-offers/${tenantId}/${offerId}`));
export const importOffersFromCards = (tenantId) => unwrap(api.post(`/sales-offers/${tenantId}/import-cards`));
/* Les modèles du catalogue et la sélection du client (2026-09-10) : le
   catalogue vit dans le code du serveur, la base ne porte que les exceptions. */
export const listOfferModels = (tenantId) => unwrap(api.get(`/sales-offers/${tenantId}/models`));
/* `patch` : { active } pour cocher ou décocher, ou n'importe quelle valeur par
   défaut du client (compte, facturation, paiement…) ; on n'envoie que ce qui change. */
export const setOfferModel = (tenantId, model, patch) =>
  unwrap(api.patch(`/sales-offers/${tenantId}/models/${model}`, patch));
// Revenus & Marges : réel de Finance sur les mois clos, Plan mensuel par compte au-delà,
// charges directes projetées par leur règle contre ce revenu (2026-09-12).
export const getRevenueMargins = (tenantId, year) => unwrap(api.get(`/sales-offers/${tenantId}/margins?year=${year}`));
// Les débiteurs générés par les ventes : facturation HT, TVA, TTC, encaissements TTC, variation des créances (2026-09-12).
export const getSalesReceivables = (tenantId, year) => unwrap(api.get(`/sales-offers/${tenantId}/receivables?year=${year}`));
